import React, { useState, useRef, useEffect } from 'react';
import { TextField, Chip, Box, Container, List, ListItem, ListItemText, CircularProgress, ListItemAvatar, Avatar, Typography } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import './FilterUser.scss'; // Import the SCSS file
import { req } from '../../ServerUtils';

const UserFilter = ({selectedUsers, setSelectedUsers}) => {
    const [inputValue, setInputValue] = useState('');
    
    const [searchResults, setSearchResults] = useState([]);
    const [loading, setLoading] = useState(false);
    const [hasSearched, setHasSearched] = useState(false);
    const wrapperRef = useRef(null);


    useEffect(() => {
        function handleClickOutside(event) {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setSearchResults([]);
                setHasSearched(false);
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleKeyDown = async (event) => {
        if (event.key === 'Enter' && inputValue && selectedUsers.length < 5) {
            setHasSearched(true);
            setLoading(true);
            req(`/linkedin-users/search?q=${inputValue}`, 'GET', null, true, 'https://api.ideakart.in').then(res => {
                setSearchResults(res);
            }).catch(err => {
                console.error('Error fetching users:', err);
            }).finally(() => {
                setLoading(false);
            });
        
        }
    };
    const handleUserSelect = (user) => {
        if (selectedUsers.length < 5 && !selectedUsers.includes(user)) {
            setSelectedUsers([...selectedUsers, user]);
            setInputValue('');
            setHasSearched(false);
            setSearchResults([]); 
        }
    };

    const handleDelete = (userToDelete) => {
        setSelectedUsers(selectedUsers.filter((user) => user.id !== userToDelete.id));
    };

    return (
        <Box 
            ref={wrapperRef}
            className="user-filter" 
        >
            <Container className="user-filter__container">
                {selectedUsers.map((user) => (
                    <Chip
                        key={user.id}
                        variant='outlined'
                        color='primary'
                        label={user.full_name}
                        onDelete={() => handleDelete(user)}
                        className="user-filter__chip" 
                    />
                ))}
            </Container>
            <TextField
                variant="outlined"
                placeholder={selectedUsers.length >= 5 ? "Maximum users selected" : "Search user..."}
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                onKeyDown={handleKeyDown}
                disabled={selectedUsers.length >= 5}
                className="user-filter__input" 
            />
            
            {(searchResults.length > 0 || loading || (hasSearched && !loading && searchResults.length === 0)) && (
                <List 
                    className="user-filter__list" 
                >
                    {loading ? (
                        <Box className="user-filter__loading">
                            <CircularProgress size={24} />
                        </Box>
                    ) : searchResults.length > 0 ? (
                        searchResults.map((user) => (
                            <ListItem 
                                button 
                                key={user.id} 
                                onClick={() => handleUserSelect(user)}
                                className={`user-filter__list-item ${selectedUsers.includes(user.full_name) ? 'selected' : ''}`} 
                            >
                                <ListItemAvatar>
                                    <Avatar src={user.picture_url} />
                                </ListItemAvatar>
                                <ListItemText 
                                    primary={
                                        <Box className="user-filter__list-item-text">
                                            {user.full_name}
                                            {selectedUsers.includes(user.full_name) && <CheckIcon className="user-filter__check-icon" />} 
                                        </Box>
                                    }
                                    secondary={user.title}
                                />
                            </ListItem>
                        ))
                    ) : hasSearched && !loading ? (
                        <ListItem className="user-filter__no-results">
                            <Typography className="user-filter__no-results-text">
                                No results found
                            </Typography>
                        </ListItem>
                    ) : null}
                </List>
            )}
        </Box>
    );
};
export default UserFilter;